import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import SelectAnimated from 'react-select/animated';
import { useDispatch, useSelector } from 'react-redux';
import { setAnswerMultiple, setAnswer, deleteAnswer } from '../../actions/questionActions';

const Dropdown = ({idPregunta,title,placeholder,options,setValor,isMultiSelect}) => {

    const dispatch = useDispatch();
    const answers = useSelector(state => state.question.answers);
    const answer = answers[idPregunta];
    const userInfo = useSelector(state => state.user.userInfo);

    const makeAnimated = SelectAnimated();
    const [selectedOptions, setSelectedOptions] = useState([]);

    useEffect(() => {
        if(answer && answer.multipleAnswers){
            const matchedOptions = (options || []).filter(option => 
                answer.multipleAnswers.some(ans => ans.answer === option.label)
            );
            setSelectedOptions(matchedOptions);
        } else {
            setSelectedOptions([]);
        }
    }, [idPregunta]);
    
    const handleOptionsChange = (optionsSelected) => {
        const prevAnswers = answer?.multipleAnswers || [];
        setSelectedOptions(optionsSelected || []);

        const optEstructured = (optionsSelected || []).map(o => {
            const existingAnswer = prevAnswers.find(ans => ans.answer === o.label);
            return {
                questionId: idPregunta,
                answerId: existingAnswer?.answerId || undefined,
                answer: o.label,
                multipleAnswers: undefined
            };
        });

        const removed = prevAnswers.filter(
            prev => !(optionsSelected || []).some(sel => sel.label === prev.answer)
        );
        removed.forEach(r => {
            if (r.answerId) {
                dispatch(deleteAnswer(r.answerId, userInfo));
            }
        });

        dispatch(setAnswer(idPregunta, undefined, undefined, optEstructured));
    };

    return (
        <div className='mb-3'>
            <label className='nombre'> {title} </label>
            <Select
                className="basic-single"
                classNamePrefix="select"
                placeholder = {placeholder}
                isClearable= {true}
                isSearchable={true}
                name= {idPregunta}
                options={options}
                value={selectedOptions}
                onChange={handleOptionsChange}
                components={makeAnimated}
                isMulti={isMultiSelect}
            />
        </div>
    );
};

export default Dropdown;